/**
 * Hover copy for inline assistant option buttons, keyed on the option's `value`.
 *
 * The API returns options as `{ text, value, color }` with no description field,
 * so these live client-side. A value with no entry here renders without a tooltip,
 * which is every option in the CV-comparison and hire-for-a-role flows.
 */
export const OPTION_TOOLTIPS: Record<string, string> = {
  // Audit type
  role_fit_performance: "Measures effectiveness in the employee's current role.",
  skills_capability_audit: "Evaluates the skills and capabilities required for success.",
  promotion_readiness: "Assesses readiness for increased responsibility and advancement.",
  leadership_potential: "Identifies potential for future leadership responsibilities.",
  team_dynamics: "Evaluates collaboration, coordination, and organizational alignment.",

  // Who the assessment is for
  specific_employee: "Evaluate an individual employee.",
  team_department: "Evaluate a group of employees working together.",
  same_role_cross_department: "Compare employees in the same role across different teams or functions.",

  // Evaluation scope
  behavioral_only: "Assess communication, collaboration, judgment, accountability, and workplace behaviors.",
  technical_only: "Assess role-specific technical knowledge, expertise, and practical skills.",
};
